import { useEffect } from 'react';
import { config } from '../global/config';
import { logTrace } from '../telemetry/logTrace';

export const InvalidSession = () => {
  useEffect(() => {
    logTrace('InvalidSession: mounted');

    const storageKey = `oidc.user:${config.idpAuthority}:${config.idpClientId}`;

    // This check makes the effect idempotent.
    // It only cleans up and redirects if the session key actually exists.
    if (localStorage.getItem(storageKey)) {
      logTrace('InvalidSession: clearing session and reloading to /');
      localStorage.removeItem(storageKey);
      globalThis.location.replace('/');
    } else {
      logTrace('InvalidSession: session key already clean, no redirect');
    }

    // If the key doesn't exist, it means we've already cleaned up.
    // This prevents a redirect loop if the user navigates back to this page.
  }, []);

  return (
    <section className="section-main section-full unhealthy-page">
      <div className="container">
        <div className="empty-state es-unhealthy-page"></div>
      </div>
    </section>
  );
};
